// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p,
h1,
h2,
h3,
h4,
span {
  margin: 0;
  padding: 0;
}

ion-col {
  padding: 0;
}

.wrapper {
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.main-icon {
  height: 100px;
  width: 100px;
  margin-bottom: 24px;
}

.title {
  font-family: AppFontBold;
  font-size: 24px;
  line-height: 100%;
  letter-spacing: -0.01em;
  text-align: center;
  text-transform: uppercase;
  text-wrap: balance;
  margin-bottom: 16px;
}

.text-1 {
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0;
  text-align: center;
  text-transform: capitalize;
  text-wrap: balance;
  margin-bottom: 16px;
}

.text-2 {
  font-size: 12px;
  line-height: 135%;
  letter-spacing: 0%;
  text-align: center;
  color: var(--color-grey);
  text-wrap: balance;
  margin-bottom: 8px;
}

.cocktail-block {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  margin-bottom: 24px;
  zoom: var(--zoom);
}
.cocktail-block .cocktail {
  height: 20px;
  width: 20px;
}
.cocktail-block .cocktail-text {
  font-family: AppFont;
  font-size: 14px;
  line-height: 135%;
  text-align: center;
  text-wrap: balance;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/payment-success/await-notification-modal/await-notification-modal.component.scss"],"names":[],"mappings":"AAAA;;;;;;EAMC,SAAA;EACA,UAAA;AACD;;AAEA;EACC,UAAA;AACD;;AAIA;EACC,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAFD;;AAKA;EACC,aAAA;EACA,YAAA;EACA,mBAAA;AAFD;;AAKA;EACC,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,mBAAA;AAHD;;AAMA;EACC,eAAA;EACA,iBAAA;EACA,iBAAA;EACA,kBAAA;EACA,0BAAA;EACA,kBAAA;EAEA,mBAAA;AAJD;;AAOA;EACC,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,kBAAA;EACA,wBAAA;EACA,kBAAA;EAEA,kBAAA;AALD;;AAQA;EACC,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;EACA,iBAAA;AALD;AAOC;EACC,YAAA;EACA,WAAA;AALF;AAQC;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EAEA,kBAAA;AAPF","sourcesContent":["p,\nh1,\nh2,\nh3,\nh4,\nspan {\n\tmargin: 0;\n\tpadding: 0;\n}\n\nion-col {\n\tpadding: 0;\n}\n\n$inline-padding: 16px;\n\n.wrapper {\n\tpadding: 24px $inline-padding;\n\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: center;\n\talign-items: center;\n}\n\n.main-icon {\n\theight: 100px;\n\twidth: 100px;\n\tmargin-bottom: 24px;\n}\n\n.title {\n\tfont-family: AppFontBold;\n\tfont-size: 24px;\n\tline-height: 100%;\n\tletter-spacing: -0.01em;\n\ttext-align: center;\n\ttext-transform: uppercase;\n\ttext-wrap: balance;\n\n\tmargin-bottom: 16px;\n}\n\n.text-1 {\n\tfont-size: 14px;\n\tline-height: 135%;\n\tletter-spacing: 0;\n\ttext-align: center;\n\ttext-transform: capitalize;\n\ttext-wrap: balance;\n\n\tmargin-bottom: 16px;\n}\n\n.text-2 {\n\tfont-size: 12px;\n\tline-height: 135%;\n\tletter-spacing: 0%;\n\ttext-align: center;\n\tcolor: var(--color-grey);\n\ttext-wrap: balance;\n\t\n\tmargin-bottom: 8px;\n}\n\n.cocktail-block {\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: center;\n\tgap: 8px;\n\tmargin-bottom: 24px;\n\tzoom: var(--zoom);\n\n\t.cocktail {\n\t\theight: 20px;\n\t\twidth: 20px;\n\t}\n\n\t.cocktail-text {\n\t\tfont-family: AppFont;\n\t\tfont-size: 14px;\n\t\tline-height: 135%;\n\t\ttext-align: center;\n\n\t\ttext-wrap: balance;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
